export default __webpack_public_path__ + "static/media/risk-veryhigh.d1df25b9.png";